const OverflowBoxHook = {
  mounted() {
    this.overflowEl = this.el.querySelector(':scope > [data-overflow-el]');
    this.overflowStartEl = this.el.querySelector(':scope > [data-overflow-start-el]');
    this.overflowEndEl = this.el.querySelector(':scope > [data-overflow-end-el]');

    this.overflowEl.addEventListener('scroll', () => {
      this.checkOverflow();
    });

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.checkOverflow();
        }
      });
    });

    this.observer.observe(this.overflowEl);

    this.checkOverflow();
  },

  updated() {
    this.checkOverflow();
  },

  destroyed() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },

  checkOverflow() {
    if (this.overflowEl.scrollLeft > 0) {
      this.overflowStartEl.dataset.enabled = true;
    } else {
      delete this.overflowStartEl.dataset.enabled;
    }

    if (this.overflowEl.scrollLeft < this.overflowEl.scrollWidth - this.overflowEl.clientWidth) {
      this.overflowEndEl.dataset.enabled = true;
    } else {
      delete this.overflowEndEl.dataset.enabled;
    }
  },
};

export default OverflowBoxHook;
